import join from 'url-join';

import { asyncAction, http, createAction } from '../../util';

const returnsApi2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const createNewReturn = asyncAction({
  baseName: 'CREATE_NEW_RETURN',
  action: action => payload => dispatch => {
    dispatch(action.start());
    return http
      .post(join(returnsApi2, '/returns'), payload)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const requestUnsubmittedReturnDetails = asyncAction({
  baseName: 'REQUEST_UNSUBMITTED_RETURN_DETAILS',
  action: action => ({ orderReturnId }) => dispatch => {
    dispatch(action.start());
    return http
      .get(join(returnsApi2, `returns/${orderReturnId}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const updateReturnDetails = asyncAction({
  baseName: 'UPDATE_RETURN_DETAILS',
  action: action => payload => dispatch => {
    dispatch(action.start());

    // remove orderReturnId key
    const finalPayload = Object.keys(payload)
      .filter(key => !key.includes('orderReturnId'))
      .reduce((obj, key) => {
        return Object.assign(obj, {
          [key]: payload[key]
        });
      }, {});

    return http
      .patch(join(returnsApi2, `returns/${payload.orderReturnId}`), finalPayload)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const submitReturn = asyncAction({
  baseName: 'SUBMIT_RETURN',
  action: action => orderReturnId => dispatch => {
    dispatch(action.start());
    return http
      .post(join(returnsApi2, `returns/${orderReturnId}/submit`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const requestSubmittedReturns = asyncAction({
  baseName: 'REQUEST_SUBMITTED_RETURNS',
  action: action => gamedayOrderId => dispatch => {
    dispatch(action.start());
    return http
      .get(
        join(returnsApi2, `/returns?filter=status(SUBMITTED)&filter=status(APPROVED)&filter=orderId(${gamedayOrderId})`)
      )
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const requestReturnsById = asyncAction({
  baseName: 'REQUEST_RETURNS_BY_ID',
  action: action => returnIds => dispatch => {
    dispatch(action.start());
    return http
      .get(join(returnsApi2, `/returns?filter=id(${returnIds.join(',')})`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const setIsReturnStep = createAction('SET_IS_RETURN_STEP');
export const setReturnData = createAction('SET_RETURN_DATA');
export const setOriginatesFromReturnStatus = createAction('SET_ORIGINATES_FROM_RETURN_STATUS');
export const setSelectedReturnId = createAction('SET_SELECTED_RETURN_ID');
export const clearPreviousReturnStepData = createAction('CLEAR_PREVIOUS_RETURN_STEP_DATA');
